//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import bus from '@/utils/bus'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    components: {
        Footer
    },
    directives: {
    },
    data() {
        return {
            currentActive: ['0'],
            // isWeixin: util.isWeiXin(),
            // isLogin: Boolean(bus.userInfo.access_token),
            strategyEntity: {},
            tabsSticky: false,
            banner: '',
            code: '',
            tipList: [],
            List: [],
            strategyId: '',
            strategyContent: {},
            minHeight: 0,
            passWord: {
                identiferId: '',
                articleSite: '',
                moduleCode: this.XXCJ_TYPE_CODE.GL,
                collTypes: this.XQSC_TYPE_CODE.GL,
                name: '',
                appCode: this.DEPT_CODE.APPCODE,
                serviceType: '400'
            },
        }
    },
    created() {
    },
    mounted() {
        this.minHeight = document.documentElement.clientHeight
        this.initData()
        sessionStorage.clear()
        this.passWord.articleSite = window.location.pathname + window.location.hash;

        /**
         * 页面滚动
         */
        window.addEventListener('scroll', this.windowScroll)
    },
    // watch: {
    //   "$route": {
    //     handler (val) {
    //       this.initData()
    //     }
    //   }
    // },
    methods: {
        jumpPage() {
            this.$router.push({
                name: 'changeStrategyContent',
                query: {
                    id: this.$route.query.id
                }
            });
        },
        getGlDetail2(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/public/tips/findById/${id}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        getNotesDetail(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/public/notes/findById/${id}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        initData: function () {

            this.getGlDetail2(this.$route.query.id)
                .then((response) => {
                    console.log(response.data);
                    if(response.data.tipsEntity.titleImageUrl && response.data.tipsEntity.titleImageUrl.includes('http')){
                        this.banner = response.data.tipsEntity.titleImageUrl
                    }else{
                        this.banner = this.PIC_BASE_URL + response.data.tipsEntity.titleImageUrl
                    }
                    this.strategyId = response.data.tipsEntity.id
                    this.strategyContent = response.data.tipsEntity
                    this.passWord.identiferId = this.strategyContent.id
                    this.passWord.name = this.strategyContent.title
                    document.title = this.strategyContent.title
                    this.tipList = response.data.catalog
                    this.tipList.forEach(item => {
                        // console.log(item.noteList[0].noteId);       
                        this.getNotesDetail(item.note[0].noteId).then((res) => {
                            //  item.content = res.data.noteSelfRelateEntity.content
                            this.$set(item, 'content', res.data.notesEntity.content)
                        })
                    });

                    //历史记录，未登录状态待完善
                    if (JSON.parse(localStorage.getItem('userInfo'))) {

                        const userInfo = JSON.parse(localStorage.getItem('userInfo')),
                            history = {
                                catalog: 1,
                                serviceType: 400,
                                title: this.strategyContent.title,
                                url: this.$route.path + '?id=' + this.$route.query.id + '&type=1',
                                userId: userInfo.id,
                                username: userInfo.username,
                                picUrl: this.strategyContent.titleImageUrl
                            }
                        // bus.$set(bus, 'history', history)
                    } else {
                        console.log('token过期');
                    }

                })
        },



    }
}
